import {
  List,
  Datagrid,
  TextField,
  DateField,
  FunctionField,
} from "react-admin";

import { Chip } from "@mui/material";

const AssessmentAssignList = (props) => {
  return (
    <List
      {...props}
      sx={{
        "& .RaDatagrid-row": {
          height: 80,
          borderRadius: "12px",
        },
        position: "sticky",
        top: 0,
        zIndex: 1,
        backgroundColor: "background.paper",
      }}
    >
      <Datagrid
        rowClick="show"
        sx={{
          "& .RaDatagrid-row": {
            borderRadius: "12px",
            mb: 1,
          },
        }}
      >
        {/* ID */}
        <TextField source="id" />

        {/* Assessment */}
        <TextField source="assessment_title" label="Assessment" />

        {/* Email */}
        <TextField source="email" />

        {/* Status */}
        <FunctionField
          label="Status"
          render={(record) => (
            <Chip
              label={record.status || "-"}
              size="small"
              color={
                record.status === "completed"
                  ? "success"
                  : record.status === "pending"
                  ? "warning"
                  : "default"
              }
            />
          )}
        />

        {/* Assigned At */}
        <DateField source="assigned_at" />

        {/* Created By */}
        <TextField source="created_by" />
      </Datagrid>
    </List>
  );
};

export default AssessmentAssignList;